/**
 * Distributor entity class
 */

/**
 * DistributorFactory
 * returns Distributor entity class
 *
 * @class DistributorFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.Distributor} class
 *
 * @ngdoc factory
 * @name mwApp.factory:DistributorFactory
 */
/* @ngInject */
export default function DistributorFactory (Entity, Type, onOffMixin) {
  /* === Distributor class === */

  /**
   * Distributor model
   *
   * @class Distributor
   * @classdesc Distributor model
   * @memberof models
   * @see models
   * @extends models.Entity
   * @mixes models.onOffMixin
   * @param {Object} [object] - initial object, containing Distributor entity fields
   * @return {models.Distributor} Distributor entity
   */
  function Distributor () {
    var obj = Entity.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  Distributor.prototype = Object.create(Entity.prototype)
  Distributor.prototype.constructor = Distributor

  /* === Distributor instance methods & fields === */

  Object.assign(Distributor.prototype, {

    /**
     * instance fields
     *
     * @memberof models.Distributor#
     * @type {Object}
     */
    _fields: {
      id: Number,
      email: String,
      activationsCount: 0,
      batchCount: 0,
      company: String,
      enabled: true,
      firstName: String,
      lastName: String,
      network: Type.Stump('Network', ['id', 'name']),
      password: String,
      vouchersLeftCount: 0
      // batches: ['VoucherBatch'],
    },

    /**
     * url template
     *
     * @memberof models.Distributor#
     * @type {String}
     */
    _urlTemplate: 'api/distributors/{{::id}}',

    /**
     * public url template
     *
     * @memberof models.Distributor#
     * @type {String}
     */
    _publicUrlTemplate: 'distributors/{{::id}}'

  }, onOffMixin)

  /* === Distributor static methods & fields === */

  // copy all static methods from Entity class
  Object.assign(Distributor, Entity)
  Distributor._name = 'Distributor'
  Distributor.init()

  // permissions
  Distributor.access = {
    view: 'viewDistributor',
    create: 'createDistributor',
    edit: 'editDistributor',
    delete: 'deleteDistributor'
  }

  // extra
  Distributor.extra = {
    networks: ['Network']
  }

  return Distributor
}
